<div class="modal">
  <div class="modal-header">
      <h2>{{ data ? 'Finalizar Análise' : 'Tempo Esgotado' }}</h2>
  </div>
  <div class="modal-content">
    <p content>{{ data ? 'Deseja realmente finalizar esta análise?' : 'Não se preocupe, todo o seu progresso foi salvo!'}}</p>
  </div>
  <div class="modal-footer">
    <ng-container *ngIf="data else timeout">
      <analysis-buttons [id]="'btnNo'" [label]="'Ainda não, quero continuar'" [kind]="'secondary'" [size]="'large'" (clicked)="closeDialog('keepAnalysis')"></analysis-buttons>
      <analysis-buttons [id]="'btnFinish'" [label]="'Finalizar'" [kind]="'primary'" [size]="'large'" (clicked)="closeDialog('completed')"></analysis-buttons>
    </ng-container>
    <ng-template #timeout>
      <analysis-buttons [id]="'btnContinue'" (clicked)="closeDialog('timeout')" [label]="'Continuar'" [kind]="'secondary'" [size]="'large'"></analysis-buttons>
    </ng-template>
  </div>

